import React, { Component } from 'react'
import compose from 'recompose/compose'
import { connect } from 'react-redux'

// Material UI
import { withTheme, withStyles } from '@material-ui/core/styles'
import Hidden from '@material-ui/core/Hidden'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import Utils from '../resources/Utils'

const styles = theme => ({
  headerTable: {
    margin: 0,
    padding: 0,
    marginTop: 16,
    fontWeight: 700
  },
  headerAmount: {
    margin: 0,
    padding: 0,
    marginTop: 16,
    fontWeight: 700,
    float: 'right',
    width: 100
  },
  smallCell: {
    margin: 0,
    padding: 0
  },
  emojiAlias: {
    marginRight: 8,
    width: 18
  },
  hidden: {
    display: 'none'
  },
  money: {
    textAlign: 'right',
    margin: 0,
    padding: 0
  }
})

class PaymentListTable extends Component {
  render() {
    const { classes } = this.props
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.smallCell}><Typography variant="subtitle2" className={classes.headerTable}>{Utils.getMessages().Payments.id}</Typography></TableCell>
            <TableCell className={classes.money}><Typography variant="subtitle2" className={classes.headerTable}>{Utils.getMessages().Payments.amount}</Typography></TableCell>
            <Hidden smDown>
              <TableCell><Typography variant="subtitle2" className={classes.headerTable}>{Utils.getMessages().Payments.date}</Typography></TableCell>
            </Hidden>
            <TableCell><Typography variant="subtitle2" className={classes.headerTable}>{Utils.getMessages().Payments.cfdi}</Typography></TableCell>
          </TableRow>
        </TableHead>
      <TableBody>
      {
        this.props.payments.map((payment, idx) => {
          return (
            <TableRow key={idx}>
              <TableCell className={classes.smallCell}>
                <Typography variant="body2">{payment.id}</Typography>
              </TableCell>
              <TableCell className={classes.money}><Typography variant="body2">$ {Utils.numberWithCommas(payment.amount)}</Typography></TableCell>
              <Hidden smDown>
                <TableCell><Typography variant="body2">{Utils.formatDate(payment.paymentAt.$date)}</Typography></TableCell>
              </Hidden>
              <TableCell>
                  <IconButton color="primary" onClick={() => { this.props.cfdi(payment) }}><SendIcon /></IconButton>
               </TableCell>
            </TableRow>
          )
        })
      }
      </TableBody>
    </Table>
    )
  }
}

const mapStateToProps = state => ({ ...state })

export default compose(
  withTheme,
  withStyles(styles),
  connect(mapStateToProps, null)
)(PaymentListTable)
